module.exports = __webpack_public_path__ + "static/media/user-md.29384158.svg";